import ResultPage from '../../modules/results/ResultPage';
export default ResultPage